import React from 'react';
import PropTypes from 'prop-types';

import LocalizedNavLink from '../router/LocalizedNavLink';

import './ParentButtonComponent.scss';

class ParentButtonComponent extends React.Component {
    render() {
        const { color, cssClass, attr, children } = this.props;
        return (
            <this.props.tag className={`bt bt-${color} ${cssClass ? cssClass : ''}`} {...attr}>
                {children}
            </this.props.tag>
        );
    }
}

ParentButtonComponent.propTypes = {
    tag: PropTypes.oneOf(['a', 'button', LocalizedNavLink]),
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    color: PropTypes.oneOf(['main', 'second', 'third', 'fourth', 'fifth', 'sixth']).isRequired,
    cssClass: PropTypes.string,
    attr: PropTypes.object.isRequired
};

export default ParentButtonComponent;



// WEBPACK FOOTER //
// ./src/components/button/ParentButtonComponent.js